import { menuClient, MenuItem } from '@/core/sdk/modules/menu/menuClient';

export const menuService = {
  /**
   * Obtiene el menú del usuario autenticado
   */
  getMenuUsuario: async (): Promise<MenuItem[]> => {
    const response = await menuClient.getMenuUsuario();

    if (!response.success || !response.data) {
      throw new Error(response.message || 'Error al obtener el menú del usuario');
    }

    return response.data;
  },
};

